// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"R4-z","colorTextValue":"S4-z","swatches":"T4-z","collapseLink":"U4-z","isCollapsed":"V4-z","dropdown":"W4-z","disabled":"X4-z"};